import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private _snackBar: MatSnackBar) {
  }

  openSnackBar(msg: any) {
    console.log(msg)
    console.log(typeof msg)
    let displayMsg: string;
    if (typeof msg === 'object') {
      if (msg.status === 401) {
        msg = 'Forbidden'
      } else if (msg.status === 403) {
        msg = msg.error.errors[0];
      } else if (msg.status === 409) {
        msg = msg.error.errors[0];
      }
    }
    switch (msg) {
      case 'E-Mail already in use.':
        displayMsg = 'E-Mail Adresse wird bereits verwendet.';
        break;
      case 'Unknown Error':
        displayMsg = 'Der Server kann derzeit nicht erreicht werden.';
        break;
      case 'Forbidden':
        displayMsg = 'Sie haben keine Berechtigung für diese Aktion.';
        break;
      case 'Not allowed to delete another admin\'s account!':
        displayMsg = 'Sie können nicht den Account eines anderen Admins löschen.';
        break;
      case 'A user cannot change their own role':
        displayMsg = 'Sie können Ihre eigene Rolle nicht ändern.';
        break;
      case 'Ihr Account wurde gesperrt. Kontaktieren Sie uns, um Ihren Account entsperren zu lassen.':
        displayMsg = 'Ihr Account wurde gesperrt.';
        break;
      case 'A user cannot lock or unlock themself':
        displayMsg = 'Sie können sich nicht selbst sperren oder entsperren.';
        break;
      case 'Map limit exceeded. User owns 100 maps already.':
        displayMsg = 'Maximale Anzahl von Wortmappen überschritten.';
        break;
      case 'User cannot share maps with himself':
        displayMsg = 'Sie können eine Mappe nicht mit sich selbst teilen.';
        break;
      case 'User not allowed to own maps':
        displayMsg = 'Mappe konnte nicht geteilt werden. Nutzer verfügt nicht über die Berechtigung, Mappen zu besitzen.';
        break;
      case 'User locked':
        displayMsg = 'Ihr Account wurde gesperrt.';
        break;
      // 403 cases
      case 'user not allowed to change their own security properties':
        displayMsg = " Sie können Ihre eigenen Sicherheitseinstellungen nicht ändern";
        break;
      case 'not allowed to change role or status of user':
        displayMsg = "Sie können die Sicherheitseinstellungen anderer Admins nicht bearbeiten";
        break;
      case 'not allowed to delete user':
        displayMsg = "Sie können andere Admins nicht löschen";
        break;
      default:
        if (msg.includes('is locked!')) {
          displayMsg = 'Ihr Account wurde gesperrt. Kontaktieren Sie uns, um Ihren Account entsperren zu lassen.';
        } else if (msg.includes('Bad credentials') || msg.includes('does not exist')) {
          displayMsg = 'E-Mail oder Passwort inkorrekt.';
        } else if (msg.includes('Could not find the user with the email address')) {
          displayMsg = 'Mappe konnte nicht geteilt werden. Es wurde kein Nutzer mit dieser E-Mail Adresse gefunden.';
        } else // Category relevant
        if (msg.includes('could not be deleted because it owns entries')) {
          displayMsg = 'Dieses Thema kann nicht gelöscht werden, da sie Einträge beinhaltet';
        } else // Category relevant
        if (msg.includes('could not be deleted because it has subcategories')) {
          displayMsg = 'Dieses Thema kann nicht gelöscht werden, da sie Unterthemen beinhaltet';
        } else {
          displayMsg = msg;
        }
    }
    this._snackBar.open(displayMsg, '', {
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      duration: 5000
    });
  }

  openSnackBarWithAction(displayMsg
                         :
                         string, action
                         :
                         string
  ) {
    const snackBarRef = this._snackBar.open(displayMsg, action, {
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      duration: 5000
    });
    return snackBarRef.onAction();
  }
}
